import { Button } from "@/components/ui/button";
import { useStoredAuth } from "@/hooks/useStoredAuth";

export default function CTASection() {
  const { isAuthenticated } = useStoredAuth();

  const handleGetStarted = () => {
    if (isAuthenticated) {
      // Scroll to top for authenticated users
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.href = "/api/login";
    }
  };

  return (
    <section id="cta" className="py-16 bg-gradient-to-r from-blue-600 to-purple-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
          ¿Listo para llevar tu IA al siguiente nivel?
        </h3>
        <p className="text-xl text-blue-100 mb-8">
          Accede a todas las herramientas premium, notebooks interactivos y contenido exclusivo
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            onClick={handleGetStarted}
            className="bg-white text-blue-600 px-8 py-3 font-semibold hover:bg-gray-100"
            size="lg"
          >
            {isAuthenticated ? "Explorar Funciones" : "Comenzar Prueba Gratuita"}
          </Button>
          <Button
            variant="outline"
            className="border-2 border-white text-white px-8 py-3 font-semibold hover:bg-white hover:text-blue-600"
            size="lg"
          >
            Ver Precios
          </Button>
        </div>
      </div>
    </section>
  );
}
